import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ForgotPassword.module.css';
import Modal from 'react-modal/lib/components/Modal';
import validator from 'validator'
import Button from "../../Components/forms/DefaultButton"
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase-config";

const ForgotPassword = (props) => {
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [disabledButton, setDisabledButton] = useState(false)

  const handleRecoverPassword = () => {
    setDisabledButton(true)
    sendPasswordResetEmail(auth, email).then(() => {
      alert(`Email de recuperação enviado com sucesso \npara ${email}\nPor favor verifique sua caixa de spam`)
      props.onRequestClose()
      setDisabledButton(false)

    }).catch((e) => {
      alert("Usuário não encontrado")
      console.error(e)
      setDisabledButton(false)
    });
  }
  const emailValidator = (e) => {
    setEmail(e.target.value)
    if (validator.isEmpty(e.target.value))
      return setEmailError('Digite um email')
    else if (!validator.isEmail(e.target.value))
      return setEmailError('Email inválido')
    else
      return setEmailError(false)
  }
  return (
    <Modal
      isOpen={props.isOpen}
      ariaHideApp={false}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
      onRequestClose={props.onRequestClose}
    >
      <button
        className="react-modal-close"
        type="button"
        onClick={props.onRequestClose}
      >&#x2715;</button>
      <div className={styles.ForgotPassword}>
        <div>
          <h1>Esqueceu sua senha?</h1>
        </div>
        <div>
          <label for="email">Digite seu email</label>
          <input
            type="email"
            name='email'
            placeholder="Email"
            onChange={(e) => emailValidator(e)}
          />
          <small className={styles.errorMsg}>{emailError}</small>
        </div>
        <Button
          type={disabledButton?'disabled':'red'}
          size="MD"
          onClick={() => { handleRecoverPassword() }}
          children="Enviar" />
      </div>
    </Modal>
  )
}
ForgotPassword.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func
}
ForgotPassword.defaultProps = {}

export default ForgotPassword;
